import ApiService from "./ApiService";

export default class PermissionService extends ApiService
{
    collection = 'permissions'

    async getRoles() {
        return this.client.get(`/api/${this.collection}/roles`)
    }
}